<template >
<div class="container-fluid">


 <div class="modal" id="PromoCouponIdentificationModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" >
    
    <div class="modal-content border border-primary ">
      <div class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">
          <i class="fas fa-search-location mr-3" aria-hidden="true"></i>
          IDENTIFICAZIONE PROMO</h4>
       <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>-->
      </div>
      <form v-on:submit.prevent="submit()">
      <div class="modal-body">        
        
        <div v-if="spinner" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="">
          
            <label for="inputEan" class="form-label">Inserire il codice a barre del Coupon</label>
            <input required type="text" id="couponBarcode" class="form-control" v-model="coupon.barcode" >
            
            <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
        </div>
        
      </div>
      <div class="modal-footer">
        <button @click="closeModal(0)" type="button" class="btn btn-secondary" >
            <!--<i style ="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>-->
            CHIUDI</button>

        <!--<button type="submit" class="btn btn-primary">
            <i style ="color:burlywood" class="fas fa-binocular mr-3" aria-hidden="true"></i>
            CERCA</button>-->
      </div>
    </form>
    </div>
    
  </div>
</div>

</div>
</template>
<script>


import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue';
import { mapGetters }             from 'vuex';


export default {
  props :['total'],
  components: {alertBox},
  
 data () {
    return {
    
    coupon    : {},
    
    //option    : 0,
    msg : {
        title : '',
        body  : '',
        type  : 0
      },
      spinner :false


    }
  },
 
  computed: {
    ...mapGetters(['company','storeId']) 
  },
mounted()
{

 //this.getData()

  
},  
created()
{
  this.$nextTick(()  => {                  
        $('#PromoCouponIdentificationModal').modal('show')
        $('#couponBarcode').trigger('focus');

    
    })  
 // this.initCoupon()
  
},
methods :{

  closeModal(total,rowId)
    {
      $('#PromoCouponIdentificationModal').modal('hide')
      this.$nextTick(()  => {              
        if(total)
        {
          this.$emit('update',total,rowId)          
        }
        else
        {
          this.$emit('close')          
        }
        
      })    
    }, 
setTotal(coupon)
{
  
  let total 
  if(coupon.typeId == 1)
  {
    total = this.total - coupon.total
    
  }
  else
  {
    const t = this.total / 100 * coupon.total
    total = this.total - t
    
  }
  this.closeModal(total,coupon.rowId)
},

async submit()
{
    
  const formatDateISO = (date) => {
    // Convert the date to ISO string
    const isoString = date.toISOString();
    // Split at the "T" character to get the date part
    const formattedDate = isoString.split("T")[0];
    return formattedDate;
  }

  const currentDate = new Date()

  let couponId 
  const rowId  = this.coupon.barcode
  if(rowId.substring(0,1).toUpperCase() == 'C')
      {
        couponId  = rowId.substring(1)                  
      }      

  this.msg.title = ''
  let sp    = {'sp'       : 'spPromoCouponIdentification'}
  let data  = {'couponId'  : couponId,
    'companyId'           : this.company.Id
    }  
  let json  = Object.assign(data, sp)

  this.spinner = true
  
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              if(res.data.recordsets[0].length == 0)
              {
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = 'COUPON INESISTENTE.'
                    this.msg.type  = 1    
                    return
                
              }

                const coupon = res.data.recordsets[0][0]
                if(coupon.active == 0)
                {
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = 'COUPON NON ATTIVO.'
                    this.msg.type  = 1    
                }
                else if(formatDateISO(currentDate) < coupon.data3 || formatDateISO(currentDate) > coupon.data4)
                {
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = 'COUPON VALIDO DAL ' + coupon.format_data3 + ' AL ' + coupon.format_data4
                    this.msg.type  = 1    
                }
                else if(this.total < coupon.total2 )
                {
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = 'TOTALE ACQUISTATO INFERIORE A SPESA MINIMA COUPON.'
                    this.msg.type  = 1    
                }
                else
                {

                    this.setTotal(coupon)
                }
              
              
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},



}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}
label,legend{
  font-weight: bold;
}
.form-check-label
{
  cursor: pointer;
}
.bigmodal{
  max-width: 35% !important;
  
}
.modal-header
{
    background-color: rgb(34, 146, 191); 
    color:rgb(3, 24, 42);
}
</style>
